import React, { useState, useEffect } from 'react';
import { useAds } from './AdProvider';

export default function FullpageAd() {
  const { fullpageAd, dismissFullpage } = useAds();
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    if (!fullpageAd) { setCanClose(false); return; }
    const timer = setTimeout(() => setCanClose(true), (fullpageAd.fullpage_timer_seconds || 5) * 1000);
    return () => clearTimeout(timer);
  }, [fullpageAd]);

  if (!fullpageAd) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {canClose && (
        <button
          onClick={dismissFullpage}
          style={{ position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', fontSize: '1.5rem', width: 40, height: 40, borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          X
        </button>
      )}
      <div style={{ maxWidth: 500, width: '90%' }} dangerouslySetInnerHTML={{ __html: fullpageAd.html_content }} />
    </div>
  );
}
